import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetAll } from '../../service/LevelService';

export default function LevelList() {
  const {
    isLoading, setIsLoading,
    setAppError, setAppErrorTitle, setAppErrorMessage, setAppErrorMode
  } = useGlobalContext();

  const [levels, setLevels] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const fetchLevelList = async (currentPage = page) => {
    try {
      setIsLoading(true);
      const response = await GetAll(currentPage, limit, keyword);
      setLevels(response.levels || []);
      setTotalPages(response.totalPages || 1);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLevelList(page); // Fetch when page changes
  }, [page]);

  const handleSearch = () => {
    setPage(1); // Reset to first page on search
    fetchLevelList(1);
  };

  return (
    <>
      <Helmet>
        <title>Level List | {config.appName}</title>
      </Helmet>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>Level List</h1>
            <span><Link to="/"> Dashboard </Link> / Level List</span>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <form>
                  <div className='row'>
                    <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label htmlFor="keyword" className="form-label">Keyword</label>
                        <div className="input-group mb-3">
                          <input
                            type="text"
                            className="form-control"
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                          />
                          <button
                            className="btn btn-outline-secondary"
                            type="button"
                            id="button-addon1"
                            onClick={handleSearch}
                          >
                            <FontAwesomeIcon icon="fa-solid fa-search" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                      <div className="p-2">
                        <div className="input-group p-4">
                          <Link className="btn btn-success" to="/level/add">
                            <FontAwesomeIcon icon="fa-solid fa-plus" /> Add Level
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <div className='table-content'>
                  <div className="mobile-scroll">
                  <table className='table table-bordered table-condensed'>
                    <thead>
                      <tr>
                        <th>Sl.no</th>
                        <th>Image</th>
                        <th>Award</th>
                        <th>Sequence</th>
                        <th>Name</th>
                        <th>Refer Count</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {levels && levels.length > 0 ? (
                        levels.map((level, index) => (
                          <tr key={level.id}>
                            <td>{(page - 1) * limit + index + 1}</td>
                            <td>
                              <img
                                src={`${config.imageBasePath}/level/${level.id}.${level.image}`}
                                alt={level.name}
                                className='img-fluid image-xs'
                              />
                            </td>
                            <td>{level.gift.name}</td>
                            <td>{level.sequence}</td>
                            <td>{level.name}</td>
                            <td>{level.referCount}</td>
                            <td>{level.status}</td>
                            <td>
                              <Link to={`/level/edit/${level.id}`} className='btn btn-sm btn-primary'>
                                <FontAwesomeIcon icon="fa-solid fa-pen-to-square" title="Edit Level" />
                              </Link>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center">No levels found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  </div>
                </div>

                 {/* Pagination Controls */}
                <div className="pagination-buttons">
                  {page > 1 && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                    >
                      Prev
                    </button>
                  )}

                  <span className="align-self-center px-3">Page {page} of {totalPages}</span>

                  {page < totalPages && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                    >
                      Next
                    </button>
                  )}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
